import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { configs } from '@constants/configs/configs';
import { ssapModalTypes } from '@constants/ssap/modals/ssapModalTypes';
import { dashboardModalTypes } from '@constants/individualPortal/dashboard/modals/dashboardModalTypes';
import { dateMethods } from '@utils/dates/dateMethods';
import { bindActionCreators } from 'redux';
import { showModal } from '@actions/common/actionCreators';
import { connect } from 'react-redux';
import { useBroker } from '@hooks/index';

const AgentPromotion = ( props ) => {
    const {
        actions: {
            showModal
        },
        environment: {
            language,
            isState,
            links: {
                CONTACT_US,
                PHONE
            },
            isFindAssistanceLinkDisabled
        },
    } = props;

    const { brokerProfile, getBrokerProfile } = useBroker();
    const [ hasBroker, setHasBroker ] = useState(true);

    //Gets broker/assister profile if user has one
    useEffect(() => {
        getBrokerProfile();
    }, []);

    //Updates the state to reflect is user has broker or not
    useEffect( () => {
        if(brokerProfile) {
            let brokerTesting = (brokerProfile && 'id' in brokerProfile ) ? brokerProfile.id  : false;
            setHasBroker(!brokerTesting);
        }
    }, [brokerProfile]);

    //Function that handles opening the locate assistance modal (a jsp modal)
    const handleOpeningModal = () => {
        showModal({
            modalType: ssapModalTypes.LOCATE_ASSISTANCE_MODAL
        });
    };

    //Function that handles the get assistance modal (the react modal)
    const handleLocateAssistanceModal = () => {
        showModal({
            modalType: dashboardModalTypes.GET_ASSISTANCE,
            modalData: { CONTACT_US, PHONE, handleOpeningModal, setForAgentPromotion, isState }
        });
    };

    //Checks if we have set the cookie for getAgentPromotion, if this exists we do not show button
    const checkForAgentPromotion = () => {
        const cookies = `; ${document.cookie}`;
        const parts = cookies.split('; dismissAgentPromo=true');
        return parts.length > 1 ? true : false;
    };

    //sets the state for show Agent promotion based off if the user has dismissed agent promotion
    const [showAgentPromotion, setShowAgentPromotion] = useState(!checkForAgentPromotion());

    //sets the cookie for dismiss agent promotion
    const setForAgentPromotion = () => {
        document.cookie = `dismissAgentPromo=true; expires${dateMethods.getFormattedDate.nextYear};`;
        setShowAgentPromotion(!showAgentPromotion);
    };


    const img_url = configs.ENV.DEVELOPMENT ? '../../../../../assets/images/headset-white.png' : '/hix/resources/spa/assets/images/headset-white.png';
    const isSelectedState = (!isState.MN && !isState.NM);

    //Determines if we show the agent promotion.
    //If you want to show agent promotion values must true which will then be turned false
    //If you don't want to show agent promotion values must be false which will then be turned into true
    let dontShowAgentPromo = !( isSelectedState && showAgentPromotion && hasBroker && !isFindAssistanceLinkDisabled);


    if (dontShowAgentPromo) { return null; }

    return (
        <div className='buttons-group'>
            <button
                type='button'
                className={classNames('usa-button broker-headset-button', `language-${language}`)}
                data-automation-id='broker-headset-button'
                onClick={() => handleLocateAssistanceModal()}>
                <img alt="" src={img_url}/>
                <span className='display-text-broker' data-automation-id='display-text-broker'><FormattedMessage id='button.get_assistance'/></span>
            </button>
        </div>
    );
};


const mapStateToProps = state => ({
    environment: state.common.environment,
    data: state.ssap.data
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        showModal,
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentPromotion);
